<template>
  <li class="menu-section">
    <h4 class="menu-text">{{ menu.section }}</h4>
    <i class="menu-icon flaticon-more-v2"></i>
  </li>
</template>

<script>
export default {
  name: "KTMenuSection",
  components: {},
  props: {
    menu: Object
  }
};
</script>
